export default __webpack_public_path__ + "static/media/thumbnailAlbaNova.63560d95.jpg";